"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessResult = exports.FailureResult = exports.Result = void 0;
class Result {
    static success(successValue) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return new SuccessResult(successValue);
    }
    static failure(failureValue) {
        return new FailureResult(failureValue);
    }
    isSuccess() {
        return this instanceof SuccessResult;
    }
}
exports.Result = Result;
class FailureResult extends Result {
    constructor(value) {
        super();
        this.value = value;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    get data() {
        return this.value;
    }
}
exports.FailureResult = FailureResult;
class SuccessResult extends Result {
    constructor(value) {
        super();
        this.value = value;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    get data() {
        return this.value;
    }
}
exports.SuccessResult = SuccessResult;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0LnV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3V0aWxzL3Jlc3VsdC11dGlscy9yZXN1bHQudXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsTUFBc0IsTUFBTTtJQUMxQixNQUFNLENBQUMsT0FBTyxDQUFJLFlBQWdCO1FBQ2hDLDZEQUE2RDtRQUM3RCxhQUFhO1FBQ2IsT0FBTyxJQUFJLGFBQWEsQ0FBSSxZQUFZLENBQUMsQ0FBQTtJQUMzQyxDQUFDO0lBRUQsTUFBTSxDQUFDLE9BQU8sQ0FBSSxZQUFlO1FBQy9CLE9BQU8sSUFBSSxhQUFhLENBQUksWUFBWSxDQUFDLENBQUE7SUFDM0MsQ0FBQztJQUVELFNBQVM7UUFDUCxPQUFPLElBQUksWUFBWSxhQUFhLENBQUE7SUFDdEMsQ0FBQztDQUdGO0FBaEJELHdCQWdCQztBQUVELE1BQWEsYUFBdUIsU0FBUSxNQUFzQjtJQUNoRSxZQUE0QixLQUFjO1FBQ3hDLEtBQUssRUFBRSxDQUFBO1FBRG1CLFVBQUssR0FBTCxLQUFLLENBQVM7SUFFMUMsQ0FBQztJQUVELDZEQUE2RDtJQUM3RCxhQUFhO0lBQ2IsSUFBSSxJQUFJO1FBQ04sT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFBO0lBQ25CLENBQUM7Q0FDRjtBQVZELHNDQVVDO0FBQ0QsTUFBYSxhQUF1QixTQUFRLE1BQXNCO0lBQ2hFLFlBQTRCLEtBQWM7UUFDeEMsS0FBSyxFQUFFLENBQUE7UUFEbUIsVUFBSyxHQUFMLEtBQUssQ0FBUztJQUUxQyxDQUFDO0lBRUQsNkRBQTZEO0lBQzdELGFBQWE7SUFDYixJQUFJLElBQUk7UUFDTixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUE7SUFDbkIsQ0FBQztDQUNGO0FBVkQsc0NBVUMifQ==